import { useEffect, useState } from 'react';

export const useMounted = (): boolean => {
  const [mounted, setMounted] = useState<boolean>(false);

  //Track mounted state in order to fix issue with hydration which is caused
  //by having multiple div elements inside on another in components from shared-lib
  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
};
